import { j as r } from "../../../../node_modules/react/jsx-runtime.js";
import { memo as p } from "react";
import { clsx as c } from "../../../../node_modules/clsx/dist/clsx.m.js";
import t from "./AvatarStatus.module.scss.js";
import s from "../../../../node_modules/react-inlinesvg/dist/index.js";
import f from "./Images/Approved.svg.js";
import l from "./Images/Declined.svg.js";
import x from "./Images/Locked.svg.js";
import d from "./Images/Missing.svg.js";
import j from "./Images/Offline.svg.js";
import u from "./Images/Online.svg.js";
import v from "./Images/Waiting.svg.js";
import y from "./Images/Company.svg.js";
const S = {
  company: /* @__PURE__ */ r.jsx(s, { src: y }),
  approved: /* @__PURE__ */ r.jsx(s, { src: f }),
  declined: /* @__PURE__ */ r.jsx(s, { src: l }),
  locked: /* @__PURE__ */ r.jsx(s, { src: x }),
  missing: /* @__PURE__ */ r.jsx(s, { src: d }),
  offline: /* @__PURE__ */ r.jsx(s, { src: j }),
  online: /* @__PURE__ */ r.jsx(s, { src: u }),
  waiting: /* @__PURE__ */ r.jsx(s, { src: v })
}, A = p((o) => {
  const { size: m = "md", className: i, avatarStatusType: a, ...e } = o, n = c(t.AvatarStatusContainer, t[m], i);
  return /* @__PURE__ */ r.jsx(
    "div",
    {
      className: n,
      ...e,
      children: S[a]
    }
  );
});
A.displayName = "AvatarStatus";
export {
  A as AvatarStatus,
  A as default
};
//# sourceMappingURL=AvatarStatus.js.map
